<template>
   <driverCarEdit v-if="isDriverEditShow" ref="DriverEditRef" orderType="edit" :parent-data="parentData" />
</template>

<script>
import driverCarEdit from "./components/driverCarEdit.vue";
import { getListDict } from "@/api/commonApi";
import {getRole} from "@/utils/getRole";
export default {
  name: "EditDriverCarForm",
  components: {
    driverCarEdit,
  },
  data() {
    return {
      tabPaneVal: "DriverEdit",
      isDriverEditShow: true,
      isVehicleTeamShow: false,
      isApplyToTeamShow: false,
      isApplyTeamRecordShow: false,
      isMyVehicleTeamShow: false,
      isMyCarrierGroupShow: false,
      isTabShow: false,
      parentData: {
        isDetail: false,
        areaOptions: this.$store.state.components.areaOptions,
        vehicleTypeAllowList: [],
        vehicleClassificationList: [],
        vehicleLengthList: [],
        vehicleWidthList: [],
        vehicleHighList: [],
        vehicleTonnageList: [],
        locationSourceList: [],
        vehicleLicenseColorList: [],
        vehicleEnergyTypeList: []
      }
    };
  },
  created() {
    //标签页的跳转
    const to = this.$route.query.to;
    if(to){
      this[`is${this.tabPaneVal}Show`] = false;
      this.tabPaneVal = to;
      this[`is${to}Show`]= true;
    }
    // 获取数据字典： 准驾车型，车型，车长，车宽，车高，吨位，定位来源，能源类型，颜色
    getListDict({ types: 'vehicleTypeAllow,vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor' }).then(response => {
      this.parentData.vehicleTypeAllowList = response.data.filter(item => item.type === 'vehicleTypeAllow')[0]['dictList']
      this.parentData.vehicleClassificationList = response.data.filter(item => item.type === 'vehicleClassification')[0]['dictList']
      this.parentData.vehicleLengthList = response.data.filter(item => item.type === 'vehicleLength')[0]['dictList']
      this.parentData.vehicleWidthList = response.data.filter(item => item.type === 'vehicleWidth')[0]['dictList']
      this.parentData.vehicleHighList = response.data.filter(item => item.type === 'vehicleHigh')[0]['dictList']
      this.parentData.vehicleTonnageList = response.data.filter(item => item.type === 'vehicleTonnage')[0]['dictList']
      this.parentData.locationSourceList = response.data.filter(item => item.type === 'locationSource')[0]['dictList']
      this.parentData.vehicleEnergyTypeList = response.data.filter(item => item.type === 'vehicleEnergyType')[0]['dictList']
      this.parentData.vehicleLicenseColorList = response.data.filter(item => item.type === 'vehicleLicenseColor')[0]['dictList']
    })
    let isCtms = getRole();
    const driver = this.$store.getters.driver;
    if ((driver && driver.driverType <= 1) || isCtms) {
      this.isTabShow = true;
    }
  },
  methods: {
    // handleClick(tab, event) {
    //   switch (tab.name) {
    //     case "VehicleTeam":
    //       this.isVehicleTeamShow = true;
    //       break;
    //     case "ApplyToTeam":
    //       this.isApplyToTeamShow = true;
    //       break;
    //     case "ApplyTeamRecord":
    //       this.isApplyTeamRecordShow = true;
    //       break;
    //     case "MyVehicleTeam":
    //       this.isMyVehicleTeamShow = true;
    //       break;
    //     case "MyCarrierGroup":
    //       this.isMyCarrierGroupShow = true;
    //       break;
    //   }
    // },
     handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList() ;
      })
    }
  }
};
</script>
